import { render, staticRenderFns } from "./FuncionarioProfile.vue?vue&type=template&id=50f4c98f"
import script from "./FuncionarioProfile.vue?vue&type=script&lang=js"
export * from "./FuncionarioProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports